import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { Config } from '@model/config';
import { AppHttpHeadersService } from '../headers/app-http-headers.service';
import { tap } from 'rxjs/operators';
import { ConfigsStorage } from '@storage/configs.storage';

@Injectable({
  providedIn: 'root',
})
export class ConfigsService {
  constructor(
    private http: HttpClient,
    private appHttpHeadersService: AppHttpHeadersService,
    private configsStorage: ConfigsStorage
  ) {}

  getConfigsList(): Observable<Config> {
    return this.http.get<Config>(environment.gateway_api + '/configs/list');
  }

  getDomainConfigs(domain: string): Observable<any> {
    return this.http.get<any>(environment.domain_config_gw_api + '/configs/landing-page/' + domain, {
      headers: this.appHttpHeadersService.getHeaders(),
    });
  }

  getPreferences(): Observable<any> {
    return this.http.get<any>(environment.gateway_api + '/configs/preferences', { headers: this.appHttpHeadersService.getHeaders() });
  }

  getConfigs(): Promise<Config> {
    return this.getConfigsList()
      .pipe(
        tap(config => {
          this.configsStorage.config = config;
        })
      )
      .toPromise();
  }
}
